import template from './toolbar.template.html';

export default {
  template,
  controller: class controller {
    constructor(
      $scope,
      $rootScope,
      $mdDialog,
      $mdMenu,
      $mdMedia,
      $mdUtil,
      $mdSidenav,
      eventService,
      authenticationService,
      Workflow,
      workflowsService,
      searchService,
      jitsiService,
      uiService,
      Ticket,
      Contact,
      SEARCH,
      INSTANCE
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.INSTANCE = INSTANCE;
      ctrl.$mdMedia = $mdMedia;
      ctrl.isAuthenticated = authenticationService.isAuthenticated();
      ctrl.isAdministrator = authenticationService.isAdministrator();
      ctrl.isConnectActive = false;
      ctrl.isConnectWithEvents = false;
      ctrl.hasMultipleOrganizations = false;
      ctrl.isDev = false;
      ctrl.online = $rootScope.online;
      ctrl.currentOrganization = {};
      ctrl.currentAccount = {};
      ctrl.availableWorkflows = [];
      ctrl.destroyWatch = null;
      ctrl.isSuspended = authenticationService.isSuspended();

      eventService.onConnectToggle((isActive) => {
        ctrl.isConnectActive = isActive;
      });
      eventService.onConnectEvents((hasEvents) => {
        ctrl.isConnectWithEvents = hasEvents;
      });

      ctrl.initialize = () => {
        workflowsService.getAvailable({ isActive: true }).then((workflows) => {
          ctrl.availableWorkflows = workflows;
        });
        ctrl.isAuthenticated = authenticationService.isAuthenticated();
        ctrl.isAdministrator = authenticationService.isAdministrator();
        ctrl.isSuspended = authenticationService.isSuspended();
        ctrl.isDev = $rootScope.isDev();
        ctrl.canSeeEnterprise = ctrl.isAuthenticated
          ? $rootScope.isDev() || $rootScope.isNlg() || $rootScope.isPtf()
          : false;
        ctrl.canSeeAssetFinanceTools = ctrl.isAuthenticated
          ? $rootScope.canSeeAssetFinanceTools()
          : false;
        ctrl.hasMultipleOrganizations = ctrl.isAuthenticated
          ? $rootScope.AvailableOrganizations.length > 1
          : false;
        ctrl.hasApplyOnlineEnabled = ctrl.isAuthenticated
          ? $rootScope.hasApplyOnlineEnabled()
          : false;
        ctrl.currentOrganization = ctrl.isAuthenticated ? $rootScope.CurrentOrganization : {};
        ctrl.currentAccount = ctrl.isAuthenticated ? $rootScope.CurrentAccount : {};
        ctrl.searchTermDeals = '';
        ctrl.searchTermReports = '';
      };

      ctrl.toggleSideNavigation = $mdUtil.debounce(() => {
        $mdSidenav('sideNav').toggle();
      }, 250);

      ctrl.toggleConnect = () => {
        eventService.connectToggle(!ctrl.isConnectActive);
      };

      ctrl.organizationChange = ($event) => {
        eventService.organizationChange({ event: $event });
      };

      ctrl.close = ($event) => {
        if ($event) {
          $event.stopPropagation();
        }
        ctrl.initialize();
        $mdMenu.destroy();
      };

      ctrl.search = (query) => searchService.getAvailable({ query });

      ctrl.quickToolAssetFinanceQuickQuote = ($event) => {
        eventService.quickToolAssetFinanceQuickQuote({ event: $event });
      };

      ctrl.quickToolAssetFinanceQuotingCalculator = ($event) => {
        eventService.quickToolAssetFinanceQuotingCalculator({ event: $event });
      };

      ctrl.quickToolHomeLoanFundingWorksheet = ($event) => {
        eventService.quickToolHomeLoanFundingWorksheet({ event: $event });
      };

      ctrl.quickToolHomeLoanMaximumBorrowing = ($event) => {
        eventService.quickToolHomeLoanMaximumBorrowing({ event: $event });
      };

      ctrl.quickToolHomeLoanCompareProducts = ($event) => {
        eventService.quickToolHomeLoanCompareProducts({ event: $event });
      };

      ctrl.quickToolHomeLoanRefinanceAnalysis = ($event) => {
        eventService.quickToolHomeLoanRefinanceAnalysis({ event: $event });
      };

      ctrl.lenderDocumentLibrary = ($event) => {
        eventService.lenderDocumentLibrary({ event: $event });
      };

      ctrl.createMeeting = ($event) => {
        $event.stopPropagation();
        uiService.toast({
          text: {
            p1: 'Meeting room',
            p2: 'is being prepared',
            p3: 'please wait ...'
          },
          progress: true
        });
        jitsiService.create().then((data) => {
          if (data.status) {
            window.open(data.url, '_blank');
          } else {
            uiService.toast({
              text: {
                p1: 'Preparation of',
                p2: 'meeting room',
                p3: 'has failed'
              },
              warn: true
            });
          }
        });
      };

      ctrl.destroyWatchConnection = eventService.onToggleConnection(() => {
        ctrl.online = $rootScope.online;
      });

      ctrl.$onInit = () => {
        ctrl.initialize();
        ctrl.destroyWatch = eventService.onCredentialsChanged(() => {
          ctrl.initialize();
        });
      };

      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
        ctrl.destroyWatchConnection();
      };
    }
  }
};
